import {Modal} from "../modal/modal.jsx";
import InputCheckbox from "../input/input-checkbox.jsx";
import Button from "../button/button.jsx";

export default function PrintOptionsModal({ open, setOpen, printRef, options, setOptions, items = [], title = "Opções de impressão" }) {
    const handleOption = (key) => {
        setOptions((prev) => {
            const nextValue = !prev[key];

            const nextOptions = {
                ...prev,
                [key]: nextValue,
            };

            if (key === "showImages" && !nextValue) {
                nextOptions.attachFullSize = false;
            }

            return nextOptions;
        });
    };

    return (
        <Modal open={open} setOpen={setOpen} title={title} className="w-4/12" overflow={true}>
            <Modal.Body className="space-y-4">
                {items.map((section) => (
                    <section key={section.title} className="space-y-2">
                        <h4>{section.title}</h4>
                        {section.options.map((item) => (
                            <InputCheckbox
                                key={item.key}
                                id={item.key}
                                label={item.label}
                                checked={!!options[item.key]}
                                onChange={() => handleOption(item.key)}
                                disabled={typeof item.disabled === "function" ? item.disabled(options) : !!item.disabled
                                }
                            />
                        ))}
                    </section>
                ))}
            </Modal.Body>
            <Modal.Footer>

                <Button onClick={() => { setOpen(false); printRef.current?.print(); }}>
                    Imprimir
                </Button>

            </Modal.Footer>
        </Modal>
    )
}